import React, { FC, useMemo } from 'react';
import { UserDetails } from '../../../models/userDetailsType';
import { useDispatch } from 'react-redux';
import useTranslation from '../../../hooks/useTranslation';
import { returnTableColumns } from './utils';
import { Stack } from '@mui/material';
import DataGridToolbarFull from '../../../common/CustomDatagridToolbar/DataGridToolbarFull';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import { useDatagridSettings } from '../../../hooks/useDatagridSettings';
import { openViewUserModal } from '../../../store/modals/actionWrappers';

type ProjectAdminTableProps = {
  userDetails: UserDetails[];
  review: boolean;
};

const AdminTable: FC<ProjectAdminTableProps> = ({ userDetails, review }) => {
  const dispatch = useDispatch();
  const settings = useDatagridSettings('adminTable');

  const t = useTranslation();
  const columns = useMemo(() => {
    return returnTableColumns(t);
  }, [t]);

  return (
    <Stack sx={{ padding: 1 }}>
      <DataGridPremium
        rows={userDetails}
        columns={columns}
        autoHeight
        pagination
        {...settings.datagridProps}
        checkboxSelection={review}
        disableRowSelectionOnClick
        slots={{
          toolbar: DataGridToolbarFull,
        }}
        slotProps={{
          toolbar: {
            handleStorage: settings.saveSettings,
          },
        }}
        disableColumnMenu
        onRowClick={(params) => dispatch(openViewUserModal(params.row.id))}
      />
    </Stack>
  );
};

export default AdminTable;
